export const UPDATE_USER = "UPDATE_USER"

export function updateUser(payload: Partial<User>) {
    return {
        type: UPDATE_USER,
        payload
    }
}
